import timezones from 'timezones-list';
import moment from 'moment-timezone';

export default {
  data() {
    return {
      isClient: false,
      step: 1,
      timezoneList: [],
      formData: {
        selectedZone: '',
        selectedZoneName: '',
        selectedCity: '',
        normalizedOffset: '',
        selectedDate: '',
        selectedTime: '',
        fullName: '',
        email: '',
        interests: [],
        notes: '',
        slotList: [],
        timeSlots: [],
        availableDateList: [],
        currentDateRange: {},        
        openTimeSlot: false
      },
      loading: false,      
      keyboardOpen: false,
      initialViewportHeight: null
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.isClient = true;
    const momentZoneList = this.getMomentTimeZoneList();
    this.timezoneList = timezones.map(tz => {
      const zone = momentZoneList.find(z => z.name == tz.tzCode);
      if (zone && zone.offset != `UTC${tz.utc}`) {
        return {        
          name:  tz.name.replace("GMT", "UTC").replace(`UTC${tz.utc}`, zone.offset),
          newname:  tz.name.replace(/^\(GMT[^\)]+\)\s*/, ""),
          label: tz.label.replace("GMT", "UTC").replace(`UTC${tz.utc}`, zone.offset),
          value: `${zone.offset} ${tz.tzCode}`,   
          offset: zone.offset,
          tzCode: tz.tzCode
        };
      } else {
        return {        
          name:  tz.name.replace("GMT", "UTC"),
          newname:  tz.name.replace(/^\(GMT[^\)]+\)\s*/, ""),
          label: tz.label.replace("GMT", "UTC"),
          value: `UTC${tz.utc} ${tz.tzCode}`,   
          offset: `UTC${tz.utc}`,
          tzCode: tz.tzCode
        };
      }
    });
    const tzName = moment.tz.guess();
    const offset = moment.tz(tzName).format("Z"); 
    this.formData.selectedZone = `UTC${offset} ${tzName}`;
    this.formData.selectedZoneName = this.formData.selectedZone.split(" ")[1] || "";
    this.formData.selectedCity = this.formData.selectedZoneName.split("/").pop() || "";
    this.formData.normalizedOffset = offset.endsWith(':00') ? `UTC${offset.slice(0, -3)}` : `UTC${offset}`;

    // only trigger this if user view form in phone
    if (localStorage.getItem('isPc') == 'false') {
      this.setViewportHeight();      
      window.addEventListener('resize', this.setViewportHeight);
      if (window.visualViewport) {
        this.initialViewportHeight = window.visualViewport.height;
        window.visualViewport.addEventListener('resize', this.handleKeyboardResize);
      }
      this.toggleIntercom(true);
    }
    this.loading = false;
  },
  beforeUnmount() {
    // only trigger this if user view form in phone
    if (localStorage.getItem('isPc') == 'false') {
      window.removeEventListener('resize', this.setViewportHeight);
      if (window.visualViewport) {
        this.initialViewportHeight = window.visualViewport.height;
        window.visualViewport.addEventListener(
          "resize",
          this.handleKeyboardResize
        );
      }
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show(val) {
      this.dialogVisible = val;
    },
  },
  methods: {
    toggleIntercom(open) {
      const tryToggle = () => {
        if (window.Intercom && typeof window.Intercom === 'function') {
          window.Intercom('update', {
            hide_default_launcher: open
          });
        } else {
          setTimeout(tryToggle, 300);
        }
      };
      tryToggle();
    },
    setViewportHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    handleKeyboardResize() {
      const vp = window.visualViewport;
      if (!vp) return;
      this.keyboardOpen = vp.height < this.initialViewportHeight - 150;
    },
    formatDate(date, fmt = 'YYYY-MM-DD') {
      if (!date) {
        return this.$moment().format(fmt);
      } else {
        return this.$moment(date).format(fmt);
      }
    },
    getMomentTimeZoneList() {
      const now = new Date();
      return moment.tz.names().map(name => {
        const offsetMinutes = moment.tz.zone(name).utcOffset(now);
        const offsetHours = -offsetMinutes / 60;
        const sign = offsetHours >= 0 ? '+' : '-';
        const hours = Math.floor(Math.abs(offsetHours)).toString().padStart(2, '0');
        const minutes = Math.abs(offsetMinutes % 60).toString().padStart(2, '0');
        const offset = `UTC${sign}${hours}:${minutes}`;
        return { name, offset };
      });
    },
    handleZoneChange(data) {    
      if (data) {
        this.formData.selectedZoneName = data.split(" ")[1] || "";
        const offset = data.split(" ")[0] || "";        
        this.formData.selectedCity = this.formData.selectedZoneName.split("/").pop() || "";
        this.formData.normalizedOffset = offset.endsWith(':00') ? offset.slice(0, -3) : offset;
      }  
    },
    handleClose() {
      this.dialogVisible = false
      this.step = 1
      if (localStorage.getItem('isPc') == 'false') {
        this.toggleIntercom(false);
      }
    },
    async handleNext() {
      const rawpath = this.$route.path;
      const base = rawpath === '/' ? '' : rawpath.replace(/\/bookdemo.*$/, '').replace(/\/$/, '');
      if (this.step == 1) {
        await this.$nextTick();
        history.pushState({ popup: 'form' }, '', `${base}/bookdemo/demoform`); 
      }
      if (this.step == 2) {
        await this.$nextTick();
        const valid = await this.$refs.bookingform.validate();
        if (!valid) {
          return;
        }             
        history.pushState({ popup: 'confirmation' }, '', `${base}/bookdemo/formconfirmation`);    
        // Meta Pixel 
        fbq('track', 'Lead');
      }
      this.step += 1;
    },
    handlePrevious() {
      if (this.step == 1) {
        this.formData.openTimeSlot = false;
        return;
      }
      const rawpath = this.$route.path;
      const base = rawpath === '/' ? '' : rawpath.replace(/\/bookdemo.*$/, '').replace(/\/$/, '');
      this.step -= 1;

      if (this.step == 1) {
        history.pushState({ popup: 'open' }, '', `${base}/bookdemo`);
      } if (this.step == 2) {
        history.pushState({ popup: 'form' }, '', `${base}/bookdemo/demoform`);
      } 
    },
    handleUpdate(key, data) {
      this.formData[key] = data;    
    },
    handleBookAgain() {
      this.step = 1;
      const rawpath = this.$route.path;
      const base = rawpath === '/' ? '' : rawpath.replace(/\/bookdemo.*$/, '').replace(/\/$/, '');
      history.pushState({ popup: 'open' }, '', `${base}/bookdemo`);
      this.formData.selectedDate = null;
      this.formData.selectedTime = null;
      this.formData.companyName = null;
      this.formData.fullName = null;
      this.formData.email = null;
      this.formData.interests = [];
      this.formData.notes = null;
    }
  },
  components: {
    "date-selection": () => localStorage.getItem('isPc') == 'true' ?
        import("@/components/PC/BookDemo/DateSelection.vue") : 
        import("@/components/APP/BookDemo/DateSelection.vue"),
    "booking-form": () => localStorage.getItem('isPc') == 'true' ?
        import("@/components/PC/BookDemo/BookingForm.vue") :
        import("@/components/APP/BookDemo/BookingForm.vue")
  }
}